import { createAsyncThunk } from '@reduxjs/toolkit'
import apiClient from '../../../services/axois'
// this is for demo purpose only / change for further api calls

export const getFaculty = createAsyncThunk('faculty/getFaculties', async () => {
  try {
    let url = `/faculties`
    const response = await apiClient.get(url)
    return response?.data?.result?.faculties // todo: need to store only "result" array inside redux state
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const getFacultyDetails = createAsyncThunk('faculty/getFacultyDetails', async (facId) => {
  try {
    let url = `/faculty/details/${facId}`
    const response = await apiClient.get(url)
    return response?.data?.result // todo: need to store only "result" array inside redux state
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const archiveFaculty = createAsyncThunk('faculty/getFaculties', async (facultyId, { dispatch }) => {
  try {
    await apiClient.post(`/faculty/${facultyId}/archive`, {
      facultyStatus: 'archive',
    })
    dispatch(getFaculty())
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const getFacultyTimetable = createAsyncThunk('faculty-timetable/getFacultyTimetable', async (filterData) => {
  try {
    let url = `/timetable`

    let query = ''
    for (const key in filterData) {
      if (filterData[key]) {
        query += `${key}=${filterData[key]}&`
      }
    }
    query = query.slice(0, -1)
    const response = await apiClient.get(`${url}?${query}`)
    // const response = await apiClient.get(`${url}`)
    return response.data.result
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})
